export const getFullName = (data: { name?: string; surname?: string }, whitespace = ' ') =>
  [data.name, data.surname].filter(Boolean).join(whitespace);
